import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { customHeaders, adminAPIURL } from '../../../../../Containers/Config/index.js';
import { GET_CASHBACK_STATEMENT, GET_CASHBACK_STATEMENT_SUCCESS, GET_CASHBACK_STATEMENT_ERROR } from '../../actions.js';
import apiCall from '../../../apiCall.js';

function* getCashbackStatement({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v2/admin/customer/statements`,
      method: 'GET',
      headers: {
        // Authorization: Constant?.CLIENT_TOKEN,
        ...filteredHeaders,
        // withCredentials: true
      },
      params: payload?.urlParams,
    });

    if (response.status === 200) {
      yield put({
        type: GET_CASHBACK_STATEMENT_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: GET_CASHBACK_STATEMENT_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_CASHBACK_STATEMENT_ERROR, payload: error });
  }
}

export function* watchgetCashbackStatement() {
  yield takeEvery(GET_CASHBACK_STATEMENT, getCashbackStatement);
}

function* getCashbackStatementSaga() {
  yield all([fork(watchgetCashbackStatement)]);
}

export default getCashbackStatementSaga;
